// PageBanner.jsx
const PageBanner = ({ title, subtitle, background, actions }) => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 overflow-hidden px-4 md:px-8 lg:px-12">
      {/* Background Image with subtle scale animation */}
      <img
        src={background}
        alt="banner background"
        className="absolute inset-0 w-full h-full object-cover object-center transform transition-transform duration-700 ease-out hover:scale-105"
        // data-aos="fade-down"
      />

      {/* Gradient Overlay */}
      {/* <div
        className="absolute inset-0  bg-gradient-to-r blur-lg from-black/80 via-black/40 to-black/60"
        // data-aos="fade-down"
      ></div> */}

      {/* Content */}
      <div
        className="relative z-10 flex flex-col justify-center h-full w-full"
        // data-aos-easing="ease-out"
      >
        <h1 className="text-white font-heading text-2xl w-full sm:text-3xl md:text-4xl lg:text-5xl font-medium tracking-wide">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/80  font-subheading text-sm sm:text-base md:text-lg mt-4 max-w-xl">
            {subtitle}
          </p>
        )}
        {actions && <div className="mt-3 flex gap-3">{actions}</div>}
      </div>
    </div>
  );
};

export default PageBanner;
